module.exports = __webpack_public_path__ + "static/media/electro_azh.d241b2c0.pdf";